import { registerComponent, getComponentConfig } from "helpers";
registerComponent(
  "my-babylist",
  class AddToBabylist extends HTMLElement {
    constructor() {
      super();

      this.modal = this.closest("dialog");
      this.button = this.querySelector("button");

      this.button.addEventListener(
        "click",
        this.handleAddToBabylist.bind(this)
      );
    }
    async handleAddToBabylist() {
        try {
            const config = JSON.parse(this.button.dataset.config);
            const { title, price, images, url } = config;
            const baseUrl = "https://www.babylist.com/bookmarklet/";
            const params = new URLSearchParams({
            "imgs[]": images,
            "price": `${price}`,
            "title": title,
            "url": url,
            "partner": window._bl.partner,
            "popup": "true"
            });
            const finalUrl = `${baseUrl}?${params.toString()}`;
            window.open(finalUrl, '_blank');
        } catch (error) {
            console.error(error);
        }
    }
  }
);